import React from "react"
//import { Link } from "gatsby"

import Header from "../components/header"
import Footer from "../components/footer"
import "../styles/main.scss"
//import "../styles/test.scss"

//import { rhythm, scale } from "../utils/typography"

export default ({ children }) => (
  <section>
   <Header />
     <div className="site-main">
       <div className="site-content">
        {children}
       </div>
      </div>
   <Footer />
  </section>
)